<template>
  <v-card class="c-content-tabs">
    <v-tabs
      v-model="currentTab"
      :background-color="headerColour"
      center-active
      fixed-tabs
      show-arrows
      :vertical="tabs.length > 2"
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.name"
        class="c-tab"
        :style="{ backgroundColor: `var(--v-${tabColour}-base)` }"
      >
        {{ tab.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="currentTab">
      <v-tab-item
        v-for="tab in tabs"
        :key="tab.name"
      >
        <v-card flat>
          <v-card-text class="g-text-oversized">
            <RichText :blocks="tab.body" />
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import RichText from '@/components/base/RichText'

export default {
  name: 'RichTabs',

  components: {
    RichText
  },

  props: {
    headerColour: {
      type: String,
      required: false,
      default: 'transparent'
    },

    tabs: {
      type: Array,
      required: true
    },

    tabColour: {
      type: String,
      required: false,
      default: 'sheet'
    }
  },

  data: function () {
    return {
      currentTab: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.c-tab {
  font-size: 1.2rem;
  letter-spacing: 0;
}
.v-tabs {
  border-bottom: solid 1px var(--v-outline-base);

  .v-tab {
    border: solid 1px var(--v-outline-base);
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;

    &.v-tab--active {
      border-color: var(--v-primary-base);
    }
    &.v-tab--active::before {
      opacity: 0.15;
    }
    &.v-tab--active:hover::before {
      opacity: 0.25;
    }
  }
}
</style>
